module.exports = __webpack_public_path__ + "static/media/Xact_Logo_Registered.249dad1c.svg";